import axios from "axios";
import { api } from "./helper";
import store from "../../store/store";
import { v4 as uuidv4 } from "uuid";

function prepareDataRequest(data) {
    return { RequestCorrelationId: uuidv4(), Data: data };
}
export function prepareRequest(data) {
    return { ...data, RequestCorrelationId: uuidv4() };
}

const client = axios.create({ baseURL: api, withCredentials: false });
client.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + store.state.user.jwt;
    return config;
});

function CreateMessageLog(item) {
    return client.post("MessageLogs/CreateMessageLog", prepareDataRequest(item));
}

function GetMessageLogsByParticipant(participantId) {
    return client.post("MessageLogs/GetMessageLogsByParticipant", prepareRequest({ participantId }));
}

export {
    CreateMessageLog,
    GetMessageLogsByParticipant,
};
